import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PersonaSurveyModalComponent } from './persona-survey-modal.component';

const COMPONENTS = [PersonaSurveyModalComponent];

@NgModule({
  imports: [
    NzButtonModule,
    NzRadioModule,
    NzCheckboxModule,
    NzModalModule,
    NzTypographyModule,
    NzGridModule,
    NzInputModule,
    NzFormModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class PersonaSurveyModalModule {}
